import { createStyles, Theme } from '@mui/material'

const styles = ({ spacing, typography, breakpoints }: Theme) =>
  // TODO: this is very similar to InvestmentFunnel presentational. DRY.
  createStyles({
    headerContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: spacing(2),
    },
    headline: {
      display: 'inline-block',
      flex: 1,
      fontSize: typography.h5.fontSize,
      [breakpoints.down('sm')]: {
        fontSize: typography.subtitle1.fontSize,
      },
    },
  })

export default styles
